const AppMutationTypes = {
    setSettings: "setSettings",
    setValidationRules: "setValidationRules",
    setUser: "setUser",
    setToken: "setToken"
};

export default AppMutationTypes;
